import { apiGet, apiPost } from '@/api/http'
import { usageEventService } from '@/services/usageEvent.service'
import type { User } from '@/types/user'

interface ApiResponse<T> {
  success: boolean
  data: T
}

export const authService = {
  async login(credentials: {
    email: string
    password: string
  }): Promise<{ user: User; accessToken: string }> {
    const response = await apiPost<ApiResponse<{ user: User; accessToken: string }>>(
      '/auth/login',
      credentials
    )
    console.log('[BdC-AuthService] Réponse brute API:', response)

    // Logger l'événement de connexion
    usageEventService.logEvent({
      eventType: 'login',
      targetType: null,
    })

    return response.data // Extraire les données de la structure { success: true, data: {...} }
  },

  async register(userData: any): Promise<{ user: User; accessToken: string }> {
    const response = await apiPost<ApiResponse<{ user: User; accessToken: string }>>(
      '/auth/register',
      userData
    )
    return response.data
  },

  async getProfile(): Promise<User> {
    const response = await apiGet<ApiResponse<User>>('/auth/profile')
    return response.data
  },

  async logout(): Promise<void> {
    // Le logout côté client est géré par le store, ici on pourrait appeler un endpoint pour invalider le token côté serveur
    return Promise.resolve()
  },

  async forgotPassword(data: { email: string }): Promise<{ message: string }> {
    const response = await apiPost<ApiResponse<{ message: string }>>('/auth/forgot-password', data)
    return response.data
  },

  async resetPassword(data: { token: string; password: string }): Promise<{ message: string }> {
    const response = await apiPost<ApiResponse<{ message: string }>>('/auth/reset-password', data)
    return response.data
  },

  async verifyEmail(token: string): Promise<{ message: string }> {
    const response = await apiGet<ApiResponse<{ message: string }>>(
      `/auth/verify-email?token=${token}`
    )
    return response.data
  },
}
